import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'grid-text-editor',
  template: `
    <label *ngIf="!showInput">{{ value }}</label>
    <input
      *ngIf="showInput"
      #input
      type="text"
      [(ngModel)]="value"
      (ngModelChange)="textUpdated()"
      class="grid-cell-edit-layout"
      [ngClass]="{
        'invalid-text': isRenbanInvalid || isModuleInvalid
      }"
      (keypress)="onKeyPress($event)"
      (input)="checkValidity()"
    />
  `,
  styles: [`
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    .grid-cell-edit-layout {
      width: 70%;
      border: 1px solid black;
      padding: 0px;
      font-size: 13px;
      height: 22px;
    }
    .invalid-text {
      border: 2px solid red !important;
    }
  `],
})
export class UpdateChildPartscountComponent {
  public params: any;
  public value: any;
  public showInput = false;

  isRenbanInvalid = false;
  isModuleInvalid = false;

  @ViewChild('input') inputRef: ElementRef<HTMLInputElement>;
  focusInput(): void {
    setTimeout(() => this.inputRef?.nativeElement?.focus(), 0);
  }
  constructor() {}

  agInit(params: any): void {
    this.params = params;
    const column = params.column;
    const data = params.data;

    // Parse countdate to Date and compare with today
    const today = new Date();
    let isTodayAllowed = false;
    const countDateStr = data?.countdate;

    if (countDateStr) {
      const [month, day, year] = countDateStr.split('/');
      const countDate = new Date(+year, +month - 1, +day);
      isTodayAllowed =
        countDate.getDate() === today.getDate() &&
        countDate.getMonth() === today.getMonth() &&
        countDate.getFullYear() === today.getFullYear();
    }

    // Assign the appropriate value and bind back reference
    switch (column) {
      case 'count_number':
        data.countNumber = this;
        this.value = data.count;
        break;

      case 'apc_value':
        data.apcValue = this;
        this.value = data.apccapacity;
        break;

      case 'renban_number':
        data.containerRenban = this;
        this.value = data.container_renban;
        break;

      case 'module_code':
        data.moduleNumber = this;
        this.value = data.module_number;
        break;
    }

    // Enable input only if countdate is today and not already saved
    this.showInput = isTodayAllowed && !data.checkedEditMode;
  }

  textUpdated() {
    const inputValue = this.value?.toString().trim();
    const column = this.params.column;

    switch (column) {
      case 'count_number':
        this.params.data.count = inputValue;
        this.params.data.countNumber = { value: inputValue };
        break;

      case 'apc_value':
        this.params.data.apccapacity = inputValue;
        this.params.data.apcValue = { value: inputValue };
        break;

      case 'renban_number':
        this.params.data.container_renban = inputValue;
        this.params.data.containerRenban = { value: inputValue };
        break;

      case 'module_code':
        this.params.data.module_number = inputValue;
        this.params.data.moduleNumber = { value: inputValue };
        break;
    }
  }

  onKeyPress(event) {
    const column = this.params.column;
    const char = event.key;
    const currentValue = event.target.value;//(event.target as HTMLInputElement).value;

    if (column === 'count_number') {
      if (!/[\d.]/.test(char)) return false;
      if (char === '.' && currentValue.includes('.')) return false;

      const parts = currentValue.split('.');
      if (parts.length === 2 && parts[1].length >= 2) return false;
      if (currentValue.length >= this.getMaxLength(column)) return false;
    }

    if (column === 'apc_value') {
      if (!/^\d$/.test(char)) return false;
      if (currentValue.length >= this.getMaxLength(column)) return false;
    }

    if (column === 'renban_number' || column === 'module_code') {
      if (!/^[a-zA-Z0-9]*$/.test(char)) return false;
      const maxLen = this.getMaxLength(column);
      if (currentValue.length >= maxLen) return false;
    }

    return true;
  }

  getMaxLength(column: string): number {
    if (column === 'count_number') return 8;
    if (column === 'apc_value') return 5;
    if (column === 'renban_number') return 5;
    if (column === 'module_code') return 4;
    return 0;
  }

  checkValidity() {
    if (this.params.column === 'renban_number') {
      this.isRenbanInvalid = this.value?.length !== 5;
    }
    if (this.params.column === 'module_code') {
      this.isModuleInvalid = this.value?.length !== 4;
    }
  }

  refresh(params: any): boolean {
    this.params = params;
    return true;
  }
}
